import { toast } from "react-toastify";
import {
  deleteServiceControll,
  nextStepServiceControll,
} from "../../../services/ServiceControllService";
import { useState } from "react";
const dayjs = require("dayjs");

export const CardControlService = (props) => {
  const [requesting, setRequesting] = useState(false);

  function nextStep() {
    const executeAction = window.confirm(
      `Mover o veículo ${props.serviceControll.vehicleDescription} para a próxima etapa do serviço?`
    );

    if (executeAction) {
      setRequesting(true);
      nextStepServiceControll(props.serviceControll.id)
        .then((response) => {
          toast.success(response);
          props.listControllServices(false);
          setRequesting(false);
        })
        .catch((error) => {
          toast.error(
            "Não foi possivel enviar ordem de serviço para a proxima etapa"
          );
          setRequesting(false);
        });
    }
  }

  function removeServiceControll() {
    const executeAction = window.confirm(
      `Confirma a exclusão irreversível do ordem de serviço do veículo ${props.serviceControll.vehicleDescription}? `
    );

    if (executeAction) {
      deleteServiceControll(props.serviceControll.id)
        .then((response) => {
          toast.success(response);
          props.listControllServices(false);
        })
        .catch((error) => {
          toast.error("Não foi possivel excluir ordem serviço");
        });
    }
  }

  return (
    <div className="col-lg-4 mb-4">
      <div 
        className="card border-0 shadow-sm rounded-4 overflow-hidden h-100" 
        style={{ transition: 'transform 0.2s' }}
        title={props.renderLateTitle(props.serviceControll)}
      >
        <div className="card-body p-4 text-center">
          
          {/* Título do Veículo */}
          <h6 className="text-uppercase fw-bold text-dark mb-3" style={{ letterSpacing: '0.5px' }}>
            {props.serviceControll.vehicleDescription.replace("_", " ")}
          </h6>

          {/* PLACA MERCOSUL (Mantida conforme seu padrão atual) */}
          <div className="d-flex justify-content-center mb-3">
             <div className="license-plate text-uppercase">
                <strong>{props.serviceControll.car.licensePlate}</strong>
             </div>
          </div>

          {/* Lista de Serviços */}
          <p className="text-muted small mb-3 text-truncate-2" style={{ minHeight: '40px' }}>
            {props.serviceControll.services.map((service) => service.name).join(", ")}
          </p>

          <hr className="opacity-25" />

          {/* Informações de Entrega e Responsável */}
          <div className="row g-0 mt-3 mb-3">
            <div className="col-6 border-end">
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: '0.65rem' }}>Previsão</div>
              <div className="fw-bold small">
                {dayjs(props.serviceControll.estimatedTime).format("DD/MM/HH:mm")}
              </div>
            </div>
            <div className="col-6">
              <div className="text-muted small fw-bold text-uppercase" style={{ fontSize: '0.65rem' }}>Responsável</div>
              <div className="small text-truncate px-2">
                <i className="fas fa-user-circle me-1 text-secondary"></i>
                {props.serviceControll.employeeName}
              </div>
            </div>
          </div>

          {/* Status com sua classe de atraso dinâmica */}
          <div className={`py-2 rounded-3 mb-4 fw-bold text-uppercase ${props.renderLateClass(props.serviceControll)}`} style={{ fontSize: '0.8rem', letterSpacing: '1px' }}>
             {props.serviceControll.status}
          </div>

          {/* Ações: Botão Principal + Dropdown */}
          <div className="d-flex gap-1 justify-content-center">
            <button
              className="btn btn-primary rounded-3 px-4 fw-bold d-flex align-items-center justify-content-center shadow-sm"
              style={{ flex: 1, height: '42px' }}
              disabled={requesting}
              onClick={nextStep}
            >
              {requesting ? <span className="spinner-border spinner-border-sm me-2"></span> : null}
              Próxima etapa
            </button>

            <div className="dropdown">
              <button
                className="btn btn-light border rounded-3 shadow-sm d-flex align-items-center justify-content-center"
                style={{ width: '42px', height: '42px' }}
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-chevron-down text-muted"></i>
              </button>
              <ul className="dropdown-menu dropdown-menu-end shadow border-0 rounded-3">
                <li>
                  <button
                    className="dropdown-item py-2"
                    onClick={() => props.handleEditServiceControll(props.serviceControll)}
                  >
                    <i className="fas fa-edit me-2 text-primary"></i> Editar
                  </button>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button className="dropdown-item py-2 text-danger" onClick={removeServiceControll}>
                    <i className="fas fa-trash-alt me-2"></i> Excluir
                  </button>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CardControlService;